<template>
    <div>
        <buttonlist @help="help" @add="add" @exps="exps" @save="save" @imp="imp" @reflash="reflash" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1" style="width: 25%;">
                <div style="background: white;white-space: nowrap;overflow: hidden;margin-top: 2px">
                    <el-button type="primary" size="mini" @click="getNode">{{ $t('getapi[928]') }}</el-button>
                    <el-button type="primary" size="mini" @click="getMaterial">{{ $t('getapi[930]') }}</el-button>
                    <el-button type="primary" size="mini" @click="getCraft">{{ $t('getapi[63]') }}</el-button>
                    <el-button type="primary" size="mini" @click="reflashTree">{{ $t('getapi[929]') }}</el-button>
                    <el-button type="primary" size="mini" @click="expTree" v-if="LoadDraw">{{ $t('getapi[922]') }}</el-button>
                </div>
                <div style="white-space: nowrap;overflow:hidden;margin-top: 2px">
                    <el-button type="primary" size="mini" @click="previous" icon="el-icon-arrow-left">{{$t('getapi[3549]')}}</el-button>
                    <el-button type="primary" size="mini" @click="next">{{$t('getapi[3550]')}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                    <el-button type="primary" size="mini" @click="Loaddrawing()" v-if="LoadDraw">{{ $t('getapi[7997]') }}</el-button>
                </div>
                <div style="height:92%;overflow: auto">
                    <div style="margin-top:5px;inbackground: white">
                        <el-scrollbar style="height:100%;">
                            <el-tree
                                    :indent="0"
                                    class="tree"
                                    :data="dataTree"
                                     :props="defaultProps"
                                     ref="tree"
                                     node-key="Part_id"
                                     @node-click="handleNodeClick"
                                     :render-content="renderContent"
                                     :default-expanded-keys="defaultEexpandedkeys"
                                     :highlight-current="true"></el-tree>
                        </el-scrollbar>
                    </div>
                </div>
                <div style="white-space: nowrap;">
                    {{$t('getapi[194]')}}:
                    <img src="../../../../assets/img/unuse.png" width="12px" height="12px" class="favicon"/>
                    {{$t('getapi[231]')}}
                </div>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <!-- <div style="width:2%;height: 100%"></div> -->
            <li class="mid1" ref="mid1" style="width: 78%;">
                <div class="box">
                    <div class="btnnowrap">
                        <el-button type="primary" :disabled="!btn.CanUse" size="mini" @click="setInvalid(1)">{{ $t('getapi[147]')}}
                        </el-button>
                        <el-button type="primary" :disabled="!btn.NotCanUse" size="mini" @click="setInvalid(0)">{{ $t('getapi[215]')}}
                        </el-button>
                        <el-button type="primary" :disabled="!btn.copy" size="mini" @click="copy">{{ $t('getapi[924]')}}</el-button>
                        <el-button type="primary" :disabled="!btn.product" size="mini" @click="showProductList">{{
                            $t('getapi[925]') }}
                        </el-button>
                        <el-button type="primary" :disabled="!btn.Purchase" size="mini" @click="showPurchaseList">{{
                            $t('getapi[926]') }}
                        </el-button>
                        <el-button type="primary" :disabled="!btn.Material" size="mini" @click="showMaterialList">{{
                            $t('getapi[927]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="showBomHistoryList">{{ $t('getapi[6112]')}}</el-button>
                        <el-button type="primary" size="mini" @click="showBomPurchaseProc">{{ $t('getapi[6113]')}}</el-button>
                        <el-button type="primary" size="mini" @click="showBomManHour">{{ $t('getapi[6114]')}}</el-button>
                        <el-button type="primary" :disabled="!btn.NotAvailable" size="mini" @click="BomNUsableToExecl">{{ $t('getapi[8179]')}}</el-button>
                        <el-button type="primary" size="mini" @click="getBomMadeList" v-if="userData.Login_DB == 'WOLVES' || userData.Login_DB == 'WOLVESTest'">{{
                            $t('getapi[12980]') }}
                        </el-button>
                        <!--<el-button type="primary" size="mini" @click="updatePartLLC" :disabled="!btn.updatepartllc">{{ $t('getapi[12713]')}}</el-button>-->
                    </div>
                    <div style="width:920px;min-width: 920px">
                        <table>
                        <tr>
                            <td style="width:80px;min-width: 80px">
                                <span>{{ $t('getapi[112]') }}</span>
                            </td>
                            <td style="width:220px;min-width: 220px">
                                <routejump :urlNo="12" v-if="dataList.versionstatus != 1">
                                    <el-input
                                            v-model="dataList.part_code"
                                            type="text"
                                            size="mini"
                                            class="mcolor"
                                            readonly
                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="showAddBom"></i>
                                    </el-input>
                                </routejump>
                                <el-input v-model="dataList.part_code" :readonly="true" class="readO"
                                          v-if="dataList.versionstatus == 1"></el-input>
                            </td>
                            <td style="width:80px;min-width: 80px">
                                {{ $t('getapi[149]') }}
                            </td>
                            <td style="width:150px;min-width: 150px">
                                <el-input v-model="dataList.part_version" :readonly="true" class="readO" style="width:100%"></el-input>
                            </td>
                            <td style="width:80px;min-width: 80px">{{ $t('getapi[410]') }}</td>
                            <td style="width:80px;min-width: 80px"> <el-input v-model="dataList.createperson" :readonly="true" class="readO" style="width:100%"
                            ></el-input></td>
                            <td style="width:80px;min-width: 80px">{{ $t('getapi[135]') }}</td>
                            <td style="width:150px;min-width: 150px"><el-date-picker v-model="dataList.createtime" type="date" :readonly="true" class="readO" style="width:100%"
                            ></el-date-picker></td>
                        </tr>
                        <tr>
                            <td>
                                {{ $t('getapi[116]') }}
                            </td>
                            <td>
                                <el-input v-model="dataList.part_name" :readonly="true" class="readO" style="width:100%"></el-input>
                            </td>
                            <td>{{ $t('getapi[552]') }}</td>
                            <td>
                                <el-input
                                        :value="dataList.versionstatus == 1 ? $t('getapi[203]') : $t('getapi[231]')"
                                        :readonly="true" class="readO"
                                ></el-input>
                            </td>
                            <td>
                                {{ $t('getapi[550]') }}
                            </td>
                            <td>
                                <el-input v-model="dataList.auditperson" :readonly="true" class="readO" style="width:100%"></el-input>
                            </td>
                            <td>{{ $t('getapi[742]') }}</td>
                            <td><el-date-picker v-model="dataList.audittime" type="date" :readonly="true" class="readO" style="width:100%"
                            ></el-date-picker></td>
                        </tr>
                        <tr>
                            <td colspan="2" style="white-space: nowrap">
                                <el-checkbox v-model="dataList.dummy_flag" disabled :true-label=1 :false-label=0
                                >{{ $t('getapi[121]')}}</el-checkbox>
                                <el-checkbox v-model="dataList.confirm_flag" :true-label=1 :false-label=0
                                >{{ $t('getapi[6381]') }}</el-checkbox>
                                <el-checkbox v-model="bomConfigIsChecked" disabled>{{ $t('getapi[123]') }}</el-checkbox>
                            </td>
                            <td>
                                {{ $t('getapi[133]') }}
                            </td>
                            <td>
                                <el-input v-model="dataList.page_no" :readonly="true" class="readO" style="width:100%"></el-input>
                            </td>
                            <td>
                                {{ $t('getapi[733]') }}
                            </td>
                            <td>
                                <el-input v-model="dataList.modifyperson" :readonly="true" class="readO" style="width:100%"></el-input>
                            </td>
                            <td>{{ $t('getapi[734]') }}</td>
                            <td>
                                <el-date-picker v-model="dataList.modifytime" type="date" :readonly="true" class="readO" style="width:100%"
                                                ></el-date-picker>
                            </td>
                        </tr>

                    </table>
                    </div>
                    
                    <div>
                        <el-tabs :tab-position="'top'" type="" style="margin-top: 3px" v-model="activeName"
                                 @tab-click="selectInfo">
                            <el-tab-pane :label="$t('getapi[721]')" name="0"  id="xdetilpane-0">
                                <div>
                                    <!-- 新增物料 -->
                                    <el-button type="primary" size="mini" @click="showItem('')" :disabled="!btn.newadd">
                                        {{ $t('getapi[6092]') }}
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="batchDelete" :disabled="!btn.rowdel">
                                        {{ $t('getapi[1522]') }}
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="searchBOM" :disabled="!btn.searchBOM">
                                        {{ $t('getapi[6115]') }}
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="transferRouting" :disabled="!btn.transfer">
                                        {{ $t('getapi[6116]') }}
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="splitRouting" :disabled="!btn.split">
                                        {{ $t('getapi[6372]') }}
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="searchPosition">
                                        {{ $t('getapi[738]') }}
                                    </el-button>
                                </div>
                                <el-table
                                        ref="singleTable"
                                        :data="dataNext"
                                        v-loading="loading"
                                        :highlight-current-row="true"
                                        show-overflow-tooltip="false"
                                        border
                                        size="mini"
                                        :height="tableHeight - 170"
                                        class="tb-edit"
                                        header-row-class-name="headerclass"
                                        :row-class-name="tableRowClassName"
                                        @selection-change="handleSelectionChange"
                                        @sort-change="sortChange"
                                        style="width: 100%;margin-top: 2px"
                                >
                                    <el-table-column type="selection"></el-table-column>
                                    <!--<el-table-column show-overflow-tooltip prop="part_id" label="ID"></el-table-column>-->
                                    <el-table-column prop="part_code" :label="$t('getapi[112]')"  sortable  width="120">
                                        <template scope="scope">
                                            <routejump :urlNo="12" :calssType="1" v-if="dataList.versionstatus != 1">
                                                <el-input
                                                        v-model="scope.row.part_code"
                                                        type="text"
                                                        class="mcolor"
                                                        size="mini"
                                                        readonly
                                                >
                                                    <i class="el-icon-edit el-input__icon" slot="suffix"
                                                       @click="showItem(scope)"></i>
                                                </el-input>
                                            </routejump>
                                            <span v-if="dataList.versionstatus == 1">{{ scope.row.part_code }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_version" sortable  :label="$t('getapi[149]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_name" sortable  :label="$t('getapi[116]')"></el-table-column>
                                    <el-table-column prop="std_qty" :label="$t('getapi[726]')" sortable  align="right">
                                        <template scope="scope">
                                            <el-input size="small" v-model="scope.row.std_qty"
                                                      v-if="dataList.versionstatus != 1"></el-input>
                                            <span v-if="dataList.versionstatus == 1">{{ scope.row.std_qty }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="routing_sequence" :label="$t('getapi[573]')" sortable  align="right">
                                        <template scope="scope">
                                            <routejump :urlNo="13" :calssType="1">
                                                <el-input
                                                        v-model="scope.row.routing_sequence"
                                                        type="text"
                                                        size="mini"
                                                        readonly=""
                                                        @change="changeRouting(scope)"
                                                >
                                                    <i class="el-icon-edit el-input__icon" slot="suffix"
                                                       @click="showRout(scope)"></i>
                                                </el-input>
                                            </routejump>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="workproc_name" sortable  :label="$t('getapi[574]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_master_unit" sortable  :label="$t('getapi[727]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="page_no" sortable 
                                                     :label="$t('getapi[133]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_spec" sortable 
                                                     :label="$t('getapi[125]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_model" sortable 
                                                     :label="$t('getapi[124]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_stuff" sortable 
                                                     :label="$t('getapi[126]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="board_flag" sortable 
                                                     :label="$t('getapi[117]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="std_qty_include_scrap" sortable  :label="$t('getapi[728]')" align="right">
                                        <template scope="scope">
                                            <el-input size="small" v-model="scope.row.std_qty_include_scrap"
                                                      v-if="dataList.versionstatus != 1"></el-input>
                                            <span v-if="dataList.versionstatus == 1">{{ scope.row.std_qty_include_scrap }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="mp_flag" :label="$t('getapi[729]')" sortable  width="100">
                                        <template scope="scope">
                                            <span v-if="scope.row.mp_flag != ''">{{scope.row.mp_flag}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="multi_material_cost" sortable  :label="$t('getapi[735]')" align="right"></el-table-column>
                                    <el-table-column prop="planning_code" sortable :label="$t('getapi[736]')">
                                        <template scope="scope">
                                            <span>{{ scope.row.planning_code | lanchange}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="bom_status" sortable  :label="$t('getapi[722]')">
                                        <template scope="scope">
                                            <span v-if="scope.row.bom_status != ''">{{ scope.row.bom_status | lanchange}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="version_status" sortable  :label="$t('getapi[7569]')">
                                        <template scope="scope">
                                            <span v-if="scope.row.version_status != ''">{{ scope.row.version_status | lanchange}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="routing_version" sortable  :label="$t('getapi[547]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="bom_routing_version" sortable  :label="$t('getapi[13282]')"></el-table-column>
                                </el-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[739]')" name="1"  id="xdetilpane-1">
                                <el-table
                                        :data="dataUp"
                                        border
                                        :height="tableHeight - 170"
                                        size="mini"
                                        :highlight-current-row="true"
                                        show-overflow-tooltip="true"
                                        stripe
                                        header-row-class-name="headerclass"
                                        @row-dblclick="getUpData"
                                        style="width: 100%"
                                        ref="singleTable1"
                                >
                                    <el-table-column show-overflow-tooltip prop="part_code"
                                                     :label="$t('getapi[740]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_version"
                                                     :label="$t('getapi[741]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="item_code"
                                                     :label="$t('getapi[137]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="routing_version"
                                                     :label="$t('getapi[547]')"></el-table-column>
                                </el-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[1067]')" name="2"  id="xdetilpane-2" v-if="dataBomConfig.length > 0">
                                <el-table
                                        :data="dataBomConfig"
                                        border
                                        :height="tableHeight - 240"
                                        size="mini"
                                        :highlight-current-row="true"
                                        show-overflow-tooltip="true"
                                        stripe
                                        header-row-class-name="headerclass"
                                        style="width: 100%"
                                >
                                    <el-table-column show-overflow-tooltip prop="config_sign"
                                                     :label="$t('getapi[3662]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_code"
                                                     :label="$t('getapi[112]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_version"
                                                     :label="$t('getapi[149]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_name"
                                                     :label="$t('getapi[116]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="self_level_qty"
                                                     :label="$t('getapi[4287]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="remark"
                                                     :label="$t('getapi[6015]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="parent_part_id"
                                                     :label="$t('getapi[827]')"></el-table-column>
                                </el-table>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    
                </div>
            </li>
        </ul>

        <!--<pick :isVisible="isVisible" ref="sel" @pick="pickclick"></pick>-->
        <selector :isVisible="isVisible" :isSplitPage=true :postUrl="'/Eng/Boms/GetBomPartDataList'"
                  @callback="pickclick" ref="sel"></selector>
        <!-- 物料弹框 -->
        <!-- <OM :isVisible="addbomvisible" @addmaterials="addmaterials" ref="addmaterials"></OM> -->
        <selector :isVisible="addbomvisible" :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="addmaterials" ref="addmaterials"></selector>
        <!-- 新增物料 按钮弹框 -->
        <!-- <itemBOM :isVisible="itevisible" @getitem="gettitemd" ref="input"></itemBOM> -->
        <selector :isVisible="itevisible" :isSplitPage=true :postUrl="'/Eng/Boms/GetBomPartList'" @callback="gettitemd"
                  ref="input"></selector>
        <!-- 工序弹框 -->
        <selector :isVisible="rouvisible" :isSplitPage=true :postUrl="'/Eng/Boms/BomRoutingSequence'"
                  @callback="getrout" ref="routs"></selector>
        <!-- <routBOM :isVisible="rouvisible" @getrout="getrout" ref="routs"></routBOM> -->
        <!-- 拷贝下级 -->
        <!--<copybom :isVisible="false" @getcopybom="getcopybom" ref="copybom"></copybom>-->
        <selector :isVisible="false" :isSplitPage=true :postUrl="'/Eng/Boms/GetCopyBomLowerLevelPopupList'"
                  @callback="getcopybom" ref="copybom"></selector>

        <el-dialog v-dialogDrag :visible.sync="isVisibleProductList" :title="$t('getapi[892]')" width="60%">
            <div>
                <el-button type="primary" size="mini" @click="expProductList">{{ $t('getapi[922]') }}</el-button>
            </div>
            <el-table
                    :data="dataSetProductList"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_master_unit"
                                 :label="$t('getapi[4590]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="mount" :label="$t('getapi[726]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="scrapMount" :label="$t('getapi[917]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="purchase_leadtime" :label="$t('getapi[893]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_first"
                                 :label="$t('getapi[169]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_second"
                                 :label="$t('getapi[170]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_third"
                                 :label="$t('getapi[171]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="planning_code"
                                 :label="$t('getapi[736]')" sortable></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisiblePurchaseList" :title="$t('getapi[891]')" width="60%">
            <div>
                <el-button type="primary" size="mini" @click="expPurchaseList">{{ $t('getapi[922]') }}</el-button>
            </div>
            <el-table
                    :data="dataSetPurchaseList"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_master_unit"
                                 :label="$t('getapi[4590]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="mount" :label="$t('getapi[726]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="scrapMount" :label="$t('getapi[917]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="purchase_leadtime" :label="$t('getapi[893]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_first"
                                 :label="$t('getapi[169]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_second"
                                 :label="$t('getapi[170]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_third"
                                 :label="$t('getapi[171]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="planning_code"
                                 :label="$t('getapi[736]')" sortable></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisibleMaterialList" :title="$t('getapi[894]')" width="60%">
            <div>
                <el-button type="primary" size="mini" @click="expMaterialList">{{ $t('getapi[922]') }}</el-button>
            </div>
            <el-table
                    :data="dataSetMaterialList"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_master_unit"
                                 :label="$t('getapi[4590]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="mount" :label="$t('getapi[726]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="scrapMount" :label="$t('getapi[917]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="purchase_leadtime" :label="$t('getapi[893]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_first" :label="$t('getapi[169]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_second" :label="$t('getapi[170]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_third"
                                 :label="$t('getapi[171]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="planning_code"
                                 :label="$t('getapi[736]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="routingsequence"
                                 :label="$t('getapi[573]')" sortable></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisibleBomHistoryList" :title="$t('getapi[8698]')" width="60%">
            <div>
                <el-button type="primary" size="mini" @click="expBomHistoryList">{{ $t('getapi[922]') }}</el-button>
            </div>
            <el-table
                    :data="dataSetBomHistoryList"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="operator" :label="$t('getapi[4584]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="operator_type"
                                 :label="$t('getapi[6048]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="operator_content"
                                 :label="$t('getapi[6068]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="newvalue" :label="$t('getapi[350]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="oldvalue" :label="$t('getapi[351]')"
                                 align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="parent_partcode"
                                 :label="$t('getapi[740]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="parent_partversion"
                                 :label="$t('getapi[741]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="partcode" :label="$t('getapi[112]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="partversion" :label="$t('getapi[149]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="operating_time"
                                 :label="$t('getapi[496]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="old_partcode" :label="$t('getapi[859]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="old_partversion"
                                 :label="$t('getapi[860]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="new_partcode" :label="$t('getapi[861]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="new_partversion"
                                 :label="$t('getapi[862]')" sortable></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisibleBomPurchaseProc" :title="$t('getapi[8699]')" width="60%">
            <div>
                <el-button type="primary" size="mini" @click="expBomPurchaseProc">{{ $t('getapi[922]') }}</el-button>
            </div>
            <el-table
                    :data="dataSetBomPurchaseProc"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_master_unit" :label="$t('getapi[4590]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="mount" :label="$t('getapi[726]')" align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="scrapMount" :label="$t('getapi[917]')" align="right" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="purchase_leadtime" :label="$t('getapi[158]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_first" :label="$t('getapi[169]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_second" :label="$t('getapi[170]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="category_third" :label="$t('getapi[171]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="planning_code" :label="$t('getapi[736]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[4364]')" sortable></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisibleBomManHour" :title="$t('getapi[6114]')" width="60%">
            <div>
                <el-button type="primary" size="mini" @click="expBomManHour">{{ $t('getapi[922]') }}</el-button>
            </div>
            <el-table
                    :data="dataSetBomManHour"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="WORKPROC_NAME" :label="$t('getapi[4364]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="workcenter_code" :label="$t('getapi[4361]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[585]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="manhour" :label="$t('getapi[581]')" align="right" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="report_measure_method" :label="$t('getapi[888]')" sortable ></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisibleBomMadeList" :title="$t('getapi[12980]')" width="60%">
            <div>
                <el-button type="primary" size="mini" @click="expBomMadeList">{{ $t('getapi[922]') }}</el-button>
            </div>
            <el-table
                    :data="dataSetBomMadeList"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="物料编码" :label="$t('getapi[112]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="物料版本" :label="$t('getapi[149]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="物料名称" :label="$t('getapi[116]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="台套数" :label="$t('getapi[12981]')" align="right" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="工艺版本" :label="$t('getapi[547]')" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="工序号" :label="$t('getapi[573]')" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="工序简称" :label="$t('getapi[574]')" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="工序描述" :label="$t('getapi[575]')" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="工时单位" :label="$t('getapi[580]')" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="工作中心" :label="$t('getapi[585]')" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="额定工时" :label="$t('getapi[581]')" align="right" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="定额单价" :label="$t('getapi[12983]')" align="right" sortable ></el-table-column>
                <el-table-column show-overflow-tooltip prop="台套工价" :label="$t('getapi[12982]')" align="right" sortable ></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisibleRouting" :title="$t('getapi[8003]')" width="25%" :close-on-click-modal="false">
            <td>
                <span>{{$t('getapi[573]')}}：</span>
            </td>
            <td>
                <el-select filterable v-model="selectRouting"  size="mini" style="margin-righ:20px">
                    <el-option v-for="item in arrRouting" :key="item.routing_index" :label="item.routing_sequence_no + '->' + item.workproc_name" :value="item.routing_index"></el-option>
                </el-select>
            </td>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isVisibleRouting = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmTransferRouting()" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="showSplitRouting" :title="$t('getapi[8003]')" width="25%" :close-on-click-modal="false">
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[573]')}}：</span>
                    </td>
                    <td>
                        <el-select filterable v-model="dataSplit.routing"  size="mini" style="margin-righ:20px">
                            <el-option v-for="item in arrSplitRouting" :key="item.routing_index" :label="item.routing_sequence_no + '->' + item.workproc_name" :value="item.routing_index"></el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[8705]')}}：</span>
                    </td>
                    <td>
                        <el-input v-model="dataSplit.amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-checkbox v-model="dataSplit.allchecked">{{ $t('getapi[8702]') }}</el-checkbox>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="showSplitRouting = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmSplitRouting()" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isVisiblePosition" :title="$t('getapi[738]')" width="25%" :close-on-click-modal="false">
            <table>
                <tr>
                    <td>
                        <span>{{ $t('getapi[8703]') }}：</span>
                    </td>
                    <td>
                        <el-input v-model="positionKey"></el-input>
                    </td>
                <tr>
                <tr>
                    <td colspan="2">
                        {{$t('getapi[8704]')}}
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isVisiblePosition = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmSearchPosition()" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'BOM',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight - 100
            },
        },
        data() {
            return {
                userData: [], // 操作人信息
                ids: '',
                showloading: '',
                isVisible: false,
                DbTbNames: '', //表名
                datajson: [],
                queryData: [],
                PageIndex: 1,
                PageSize: 50,
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataList: {}, //详情
                oldDataList: {}, // 记录老数据
                PartId: '', //物料流水号
                iscopy:0,//是否拷贝下级
                exclusively_id:0,//选择根节点物料id
                IsAdd: 0, // 是否新增
                dataBomConfig: [], //如果数组为空则配置件为false
                bomConfigIsChecked: false, // 配置件是否勾选
                dataTree: [], //根节点的树
                id_tree: 0,
                defaultProps: {
                    children: 'Children',
                    label: 'Part',
                    part_id: 'Part_id'
                },
                level0Part: '', // 根目录label
                //删除行信息
                delrows: [],
                dataNext: [], // 下级信息
                nextIsEdit: false, // 下一级菜单是否为编辑
                dataUp: [], // 上级信息
                itevisible: false, //物料弹框
                rouvisible: false, //工序弹框
                addbomvisible: false, // 新增物料弹框
                roushowindex: -1,
                addoredit: 1,
                detail_add: [],
                dataChecked: [],

                isVisibleProductList: false,
                isVisiblePurchaseList: false,
                isVisibleMaterialList: false,
                isVisibleBomHistoryList: false,
                isVisibleBomPurchaseProc: false,
                isVisibleBomManHour: false,
                dataSetProductList: [],
                dataSetPurchaseList: [],
                dataSetMaterialList: [],
                dataSetBomHistoryList: [],
                dataSetBomPurchaseProc: [],
                dataSetBomManHour: [],
                isVisibleBomMadeList: false,
                dataSetBomMadeList:[],
                btn: {
                    copy: false,
                    product: false,
                    Purchase: false,
                    Material: false,
                    NotCanUse: false,
                    CanUse: false,
                    rowdel: false,
                    newadd: false,
                    searchBOM: false,
                    transfer: false,
                    split: false,
                    NotAvailable:false,
                    updatepartllc: false,//更新底层码
                },
                routing_version: '', //工艺版本
                isVisibleRouting: false,
                arrRouting: [],
                selectRouting: 1, //选择的工序
                showSplitRouting: false, // 拆分物料工序弹窗
                dataSplit: {
                    routing: '',
                    amount: '',
                    allchecked: false
                },
                arrSplitRouting: [],
                isVisiblePosition: false,
                positionKey: '',
                searchindex: -1,
                searchData: [],
                defaultEexpandedkeys: [],
                parentid: '',
                activeName: 0,
                RightSelectIndex: 0,
                LoadDraw:false,
            };
        },
        watch: {
            dataNext: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.RightSelectIndex)
                })
            },
            dataUp: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.RightSelectIndex)
                })
            },
            dataBomConfig: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.RightSelectIndex)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('BOM', that)
            that.dataNext = [];
            that.dataTree = {
                Part: '铆螺母-100107─→A',
                Part_id: 39948,
                Children: [
                    {Part_id: 1529, Part: '040300134─→A/0', Children: []},
                    {
                        Part_id: 1742,
                        Part: '040300348─→A/0',
                        Children: []
                    }
                ]
            };
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.oldDataList = JSON.stringify(that.dataList)
            that.add();
            that.authority();
            that.$limits.dragControllerDiv1();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name);
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = '100%';
                } else {
                    left[0].style.width = '100%';
                    mid[0].style.width = '0px';
                }
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.UnOperationAuthority('plv2', 31, 1)) {
                    that.$refs.SetBtn.SetButtonEnable('refresh,export');
                }
                //操作权限-查询级别
                let ilimits = that.$limits.UnOperationAuthority('plv2', 31, 1);
                
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (ilimits) {
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('create,save,refresh,export');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('create,save,refresh,export');
                        break;
                    default:
                        that.$refs.SetBtn.SetButtonEnable('');
                        break;
                }
                that.$refs.SetBtn.InputBtnRight('T01_Bom');
                that.btnauthority();
            },
             //查看图纸
             Loaddrawing() {
                let that=this;
                
                if(that.$limits.fnIsEmpty(that.dataList.part_code)){
                    return;
                }
                let item = {
                    //技术文档
                    label:  this.$t('getapi[6575]'),
                    name: 'docmanageview',
                    path: '/docmanageview',
                    url: '/docmanageview',                  
                    icon: 'video-play'
                };
                // 跳转前存储数据
                 that.$store.commit('setSharedParams', {
                     part_code: that.dataList.part_code
                 });
                this.$router.push({ path: '/docmanageview'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            btnauthority() {
                //单据右键按钮功能
                let that = this;
                that.btn.NotCanUse = false;
                that.btn.CanUse = false;
                that.btn.copy = false;
                that.btn.product = false;
                that.btn.Purchase = false;
                that.btn.Material = false;
                that.btn.rowdel = false;
                that.btn.newadd = false;
                that.btn.searchBOM = false
                that.btn.split = false
                that.btn.transfer = false
                that.btn.updatepartllc = false
                if (that.$limits.authority('plv4', 219, 1) == 1) {
                    that.btn.updatepartllc = true
                }
                if(that.dataChecked.length > 0){
                    that.btn.transfer = true
                    that.btn.transfer = that.dataChecked.every(val => {
                        return val.bom_status == '不可用'
                    });
                }
                if(that.dataChecked.length == 1 && that.dataChecked[0].bom_status == '不可用'){
                    that.btn.split = true
                }
                if (that.dataChecked.length == 1) {
                    that.btn.searchBOM = true
                }
                if (that.dataList.versionstatus == 0) {
                    that.btn.newadd = true;
                    if (that.dataChecked.length > 0) {
                        that.btn.rowdel = true;
                    } else {
                        that.btn.rowdel = false;
                    }
                } else {
                    that.btn.rowdel = false;
                }
                //新增
                if (that.id_tree == 0) {
                    that.btn.copy = true;
                } else {
                    that.btn.copy = false;
                }
                if (that.dataNext.length > 0) {
                    that.btn.copy = false;
                } else {
                    that.btn.copy = true;
                }
                if (that.$limits.authority('plv2', 31, 1) == 1) {
                    that.btn.Material = true;
                    that.btn.Purchase = true;
                } else {
                    // that.btn.copy = true;
                    that.btn.product = true;
                    if (that.$limits.authority('plv4', 6, 1) == 0) {
                        that.btn.NotCanUse = false;
                        that.btn.CanUse = false;
                        that.btn.Material = true;
                        that.btn.Purchase = true;
                    } else {                        
                        if(that.$limits.fnIsEmpty(that.PartId)){
                            that.btn.NotCanUse = false;
                            that.btn.CanUse = false;
                            that.btn.copy = false;
                            that.btn.product = false;
                            that.btn.Material = true;
                            that.btn.Purchase = true;
                            return;
                        }   
                        if(that.addoredit!=1){//判断是否为新增 1 为新增
                            //可用
                            if (that.dataList.versionstatus==1) {
                                that.btn.Material = true;
                                that.btn.Purchase = true;
                                that.btn.NotCanUse = true;
                                that.btn.CanUse = false;
                                return;
                            }
                            //不可用
                            if (that.dataList.versionstatus==0) {
                                that.btn.Material = true;
                                that.btn.Purchase = true;
                                that.btn.CanUse = true;
                                that.btn.NotCanUse = false;
                                return;
                            }
                        }
                            
                    }
                }
            },
            //表格背景
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
                if(this.dataList.dummy_flag==0){
                    
                    if (row.version_status=='不可用') {
                        return 'red';
                    } 
                    
                    if (row.routing_version!=row.bom_routing_version) {
                        return 'yellow';
                    }
                }
                

            },
            // 添加bom
            showAddBom() {
                let that = this;
                if (that.dataList.part_code == '') {
                    that.addbomvisible = true;
                    that.$refs.addmaterials.clearInput(that.addbomvisible);
                }
            },
            addmaterials(row) {
                let that = this;
                console.log(row)
                that.PartId = row.exclusively_id
                that.dataList.parentpartid = row.exclusively_id;
                that.dataList.partid = ''
                that.dataList.part_code = row.part_code;
                that.dataList.part_name = row.part_name;
                that.dataList.part_version = row.part_version;
                that.dataList.dummy_flag = row.dummy_flag;
                that.dataList.versionstatus = 0;
                that.dataList.page_no = row.page_no;
                that.dataList = {...that.dataList};
                that.btnauthority();
            },
            // 刷新
            reflash() {
                let that = this;
                /* if(that.id_tree!=0 && that.dataList.parentpartid != undefined) {
                        that.getBOMTree(that.id_tree)
                        that.getBOMInfo(that.dataList.parentpartid)
                    }*/
                if (that.addoredit == 1) {
                    that.add();
                } else {
                    if (that.PartId != 0) {
                        that.getBOMInfo(that.PartId)
                    }
                }
            },
            //新增
            add() {
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.dataTree = [];
                that.PartId = 0;
                that.IsAdd = 1;
                that.dataList = {
                    part_code: '',
                    part_version: '',
                    part_name: '',
                    dummy_flag: 0,
                    partid: 0,
                    parentpartid: 0,
                    selflevelqty: 0,
                    versionstatus: 0,
                    assemblyqty: 0,
                    scatterqty: 0,
                    createperson: '',
                    createtime: '',
                    modifyperson: '',
                    modifytime: '',
                    audittime: '',
                    auditperson: '',
                    optionalflag: 0,
                    remark: '',
                    scrap_rate: 0,
                    routingversion: '',
                    bomvension: 0,
                    bomdatetime: ''
                };
                that.oldDataList = JSON.stringify(that.dataList)
                that.dataNext = [];
                that.dataUp = [];
                that.addoredit = 1;
                that.authority();
            },
            // 查询
            getNode() {
                this.isVisible = true;
                this.$refs.sel.clearInput(this.isVisible, '');
            },
            // 刷新树
            reflashTree() {
                let that = this;
                that.getBOMTree(that.id_tree);
                that.authority();
                that.btnauthority();
            },
            // 双击选取根节点物料
            pickclick(val) {
                let that = this;
                console.log(val)
                that.routing_version = val.routing_version
                that.level0Part = val.part_code + '─→' + val.part_version;
                that.exclusively_id=val.exclusively_id;//选择根节点物料id
                that.getBOMTree(val.exclusively_id);
                that.getBOMInfo(val.exclusively_id);
                that.authority();
                that.btnauthority();
            },
            // 获取BOM树数据
            getBOMTree(id) {
                let that = this;
                that.id_tree = id;
                let parm = {
                    Id: id
                };
                that.$http.urlpost('/Eng/Boms/GetPartBomTree', parm, function (res) {
                    if (res.Success == 1) {
                        let tree = res.DataContent.listTree;
                        that.dataTree = [
                            {
                                Part: '',
                                Part_id: '',
                                Bom_status: 0,
                                Children: []
                            }
                        ];
                        if (tree.length > 0) {
                            that.dataTree[0].Part = that.level0Part;
                            that.dataTree[0].Part_id = tree[0].Parent_part_id;
                            that.dataTree[0].Children = tree;
                            that.parentid = tree[0].Parent_part_id
                            that.authority();
                        } else {
                            that.dataTree[0].Part = that.level0Part
                            that.dataTree[0].Part_id = id;
                            that.dataTree[0].Children = tree;
                            that.parentid = id
                            that.authority();
                        }
                        that.searchindex = -1
                        that.searchData = []
                        that.getSearchNode().filter(that.dataTree)
                        console.log('数组' + that.searchData)
                    }
                });
            },
            getBOMInfo(id) {
                let that = this;
                that.addoredit = 2;
                that.PartId = id
                let parm = {
                    Id: id
                };
                that.$http.urlpost('/Eng/Boms/GetAllPartBomInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.LoadDraw=true;
                        that.IsAdd = 0;
                        that.dataNext = res.DataContent.listNextModel;
                        that.$refs.singleTable.clearSort();
                        that.dataUp = res.DataContent.listUpModel;
                        that.dataList = res.DataContent.bomModel;
                        if(that.dataList.versionstatus!=1){
                            that.btn.NotAvailable=true;
                        }
                        else{
                            that.btn.NotAvailable=false;
                        }
                        that.dataBomConfig = res.DataContent.listBomConfig;
                        if (that.dataBomConfig.length > 0) {
                            that.bomConfigIsChecked = true;
                        } else {
                            that.bomConfigIsChecked = false;
                        }
                        that.oldDataList = JSON.stringify(that.dataList)
                        
                        that.authority();
                    }
                    else{
                        that.LoadDraw=false;
                    }
                });
            },
            // 选取树节点
            handleNodeClick(data) {
                console.log(data);
                let that = this;
                that.PartId = data.Part_id;
                that.getBOMInfo(data.Part_id);
                that.authority();
                that.btnauthority();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
            },
            // 控制行显隐
            tableRowClassNamefunction(row, index) {
                if (row.IsDelete == 1) {
                    return 'hidden-row';
                }
                return '';
            },
            delline(row) {
                let line = row.$index;
                if (row.row.IsAdd == 1) {
                    this.dataNext.splice(line, 1);
                } else {
                    this.dataNext[line].IsDelete = 1;
                }
            },
            // 双击选取物料
            showItem(row) {
                if (row != '') {
                    // 修改
                    this.roushowindex = row.$index;
                    console.log(this.dataNext)
                    console.log(this.roushowindex)
                } else {
                    //新增
                    this.roushowindex = -1;
                }
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            // 选取物料主文件
            gettitemd(val) {
                let that = this;
                that.iscopy=0;
                // if (val.mp_flag == 0) {
                //     val.mp_flag = '采购'
                // } else if (val.mp_flag == 1) {
                //     val.mp_flag = '制造'
                // } else {
                //     val.mp_flag = ''
                // }
                if (this.roushowindex < this.dataNext.length && this.roushowindex != -1) {
                    this.dataNext[this.roushowindex].part_id = val.exclusively_id;
                    this.dataNext[this.roushowindex].parent_part_id = '';
                    this.dataNext[this.roushowindex].part_code = val.part_code;
                    this.dataNext[this.roushowindex].part_name = val.part_name;
                    this.dataNext[this.roushowindex].part_version = val.part_version;
                    this.dataNext[this.roushowindex].std_qty = '';
                    this.dataNext[this.roushowindex].part_master_unit = val.part_master_unit;
                    this.dataNext[this.roushowindex].part_spec = val.part_spec;
                    this.dataNext[this.roushowindex].part_model = val.part_model;
                    this.dataNext[this.roushowindex].part_stuff = val.part_stuff;
                    this.dataNext[this.roushowindex].scatter_qty = '';
                    this.dataNext[this.roushowindex].bom_status = '';
                    this.dataNext[this.roushowindex].mp_flag = val.mp_flag;
                    this.dataNext[this.roushowindex].multi_material_cost = '';
                    this.dataNext[this.roushowindex].create_person = '';
                    this.dataNext[this.roushowindex].create_time = '';
                    this.dataNext[this.roushowindex].audit_time = '';
                    this.dataNext[this.roushowindex].audit_person = '';
                    this.dataNext[this.roushowindex].modify_person = '';
                    this.dataNext[this.roushowindex].modify_time = '';
                    this.dataNext[this.roushowindex].std_qty_include_scrap = '';
                    this.dataNext[this.roushowindex].planning_code = val.planning_code;
                    this.dataNext[this.roushowindex].parent_routing_no = '1';
                    this.dataNext[this.roushowindex].routing_sequence = '';
                    this.dataNext[this.roushowindex].workproc_name = '';
                    this.dataNext[this.roushowindex].page_no = val.page_no;
                    this.dataNext[this.roushowindex].board_flag = val.board_flag;
  /*                  this.dataNext[this.roushowindex].exclusively_id = '';*/
                    this.dataNext[this.roushowindex].IsAdd = 0;
                    this.dataNext[this.roushowindex].IsDelete = 0;
                } else {
                    this.dataNext = [
                        ...this.dataNext,
                        {
                            part_id: val.exclusively_id,
                            parent_part_id: '',
                            part_code: val.part_code,
                            part_name: val.part_name,
                            part_version: val.part_version,
                            std_qty: '',
                            part_master_unit: val.part_master_unit,
                            part_spec: val.part_spec,
                            part_model: val.part_model,
                            part_stuff: val.part_stuff,
                            mp_flag: val.mp_flag,
                            scatter_qty: 0,
                            bom_status: '',
                            multi_material_cost: '',
                            create_person: '',
                            create_time: '',
                            audit_time: '',
                            audit_person: '',
                            modify_person: '',
                            modify_time: '',
                            std_qty_include_scrap: '',
                            planning_code: val.planning_code,
                            parent_routing_no: '1',
                            routing_sequence: '',
                            workproc_name: '',
                            exclusively_id: '',
                            page_no: val.page_no,
                            board_flag:val.board_flag,
                            IsAdd: 1,
                            IsDelete: 0
                        }
                    ];
                    that.$nextTick(() => {
                        that.$refs.singleTable.setCurrentRow(that.dataNext[that.dataNext.length - 1]);
                    })
                }
            },
            // 双击选取工序
            showRout(row) {
                let that = this
                this.rouvisible = true;
                this.roushowindex = row.$index;
                let param = {
                    ID: that.dataList.parentpartid
                }
                this.$refs.routs.clearInputMain(this.rouvisible, param);
            },
            getrout(val) {
                console.log(val);
                this.dataNext[this.roushowindex].parent_routing_no = val.routing_index;
                this.dataNext[this.roushowindex].routing_sequence = val.routing_sequence;
                this.dataNext[this.roushowindex].workproc_name = val.workproc_description;
                this.dataNext[this.roushowindex].routing_version = val.routing_version;
            },
            // 手动输入工序
            changeRouting(row){
                let that = this
                let LanType = 1
                if(window.localStorage.getItem('lang')=='zh'){
                    LanType=1;
                }else if(window.localStorage.getItem('lang')=='en'){
                    LanType=2;
                }else if(window.localStorage.getItem('lang')=='hu'){
                    LanType=3;
                }
                let parm = {
                    ID: that.dataList.parentpartid,
                    LangType: LanType
                }
                that.$http.urlpost('/Eng/Boms/BomRoutingSequence', parm, function(res) {
                    if (res.Success == 1 && res.DataContent != null) {
                        let arr = res.DataContent.DataList
                        let flag = false
                        for(let i=0;i<arr.length;i++){
                            if(row.row.routing_sequence == arr[i].routing_sequence){
                                flag = true
                            }
                        }
                        if(flag == false){
                            row.row.routing_sequence = row.row.old_routing_sequence
                        }
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                that.loading = true;
                that.btn.CanUse=false;
                let datetime = Common.methods.getDatetime()
                if (that.addoredit == 1) {
                    that.dataList.createperson = that.userData.username;
                    that.dataList.createtime = datetime;
                }
                that.dataList.modifyperson = that.userData.username;
                that.dataList.modifytime = datetime;
                let parm = {
                    PartId: that.PartId,
                    IsAdd: that.IsAdd,
                    iscontinue: 0,
                    iscopy:that.iscopy,
                    bomModel: that.dataList,
                    listNextModel: that.dataNext,
                    listBomConfig: that.dataBomConfig,
                    LangType: that.$processdata.getLang(),
                };
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Eng/Boms/SaveData', parm, function (res) {
                    that.loading = false;
                    that.btn.CanUse=true;
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.iscopy=0;
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.PartId = res.UniqueNum;
                        that.getBOMInfo(that.PartId);
                    } else if (res.Success == 2) {
                        that.$confirm(that.$t('getapi[8601]'), that.$t('getapi[194]'), {//'BOM中工序号都是相同工序，继续保存吗?'
                            confirmButtonText: that.$t('getapi[2051]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                let data = {
                                    PartId: that.PartId,
                                    IsAdd: that.IsAdd,
                                    iscontinue: 1,
                                    iscopy:that.iscopy,
                                    bomModel: that.dataList,
                                    listNextModel: that.dataNext,
                                    listBomConfig: that.dataBomConfig,
                                    LangType: that.$processdata.getLang(),
                                };
                                that.loading = true;
                                that.btn.CanUse=false;
                                that.$http.urlpost('/Eng/Boms/SaveData', data, res1 => {
                                    that.loading = false;
                                    that.btn.CanUse=true;
                                    if (res1.Success == 1) {
                                        that.iscopy=0;
                                        that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                        that.PartId = res1.UniqueNum;
                                        that.getBOMInfo(that.PartId);
                                        
                                    }
                                });
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });

            },
            setInvalid(value) {
                let that = this;
                if (value == 0) {
                    let parm = {
                        Id: that.dataList.parentpartid,
                        Code: '',
                        Name: '',
                        Where: ''
                    };
                    that.$http.urlpost('/Eng/Boms/NotUseBOMVension', parm, res => {
                        if (res.Success == 1) {
                            that.getBOMInfo(that.dataList.parentpartid);
                        }
                    });
                } else if (value == 1) {
                    let parm = {
                        Id: that.dataList.parentpartid,
                        IsReplace: 0
                    };
                    that.$http.urlpost('/Eng/Boms/CanUseBOMVension', parm, res => {
                        if (res.Success == 2) {
                            that.$confirm(that.$t('getapi[8700]'), that.$t('getapi[194]'), {//当前BOM存在另外一个可用的版本,是否替换?
                                confirmButtonText: that.$t('getapi[2052]'),
                                cancelButtonText: that.$t('getapi[2053]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    let data = {
                                        Id: that.dataList.parentpartid,
                                        IsReplace: 1
                                    };
                                    that.$http.urlpost('/Eng/Boms/CanUseBOMVension', parm, res => {
                                        that.getBOMInfo(that.dataList.parentpartid);
                                    });
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });
                        } else {
                            that.getBOMInfo(that.dataList.parentpartid);
                        }
                    });
                }
            },
            // 导出下一级别
            exps() {
                let that = this;
                that.loading = true;
                let parm = {
                    Id: that.PartId,
                    Code: '',
                    Name: '',
                    Where: '',
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[745]')
                };
                that.$http.urlpost('/Eng/Boms/BomChildrenToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.loading = false;
                });
            },
            //导出树
            expTree() {
                let that = this;
                that.loading = true;
                let parm = {
                    Id: that.PartId,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[68]')
                };
                that.$http.urlpost('/Eng/Boms/GetBomPartTreToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.loading = false;
                });
            },
            // 过滤需要显示的数组
            filter(arr) {
                if (arr.length == 0) {
                    return;
                }
                let array = arr.filter(item => {
                    return item.IsDelete != 1;
                });
                return array;
            },
            handleSelectionChange(val) {
                let that = this;
                that.dataChecked = [];
                for (let i = 0; i < val.length; i++) {
                    that.dataChecked.push(val[i]);
                }
                that.btnauthority();
            },
            batchDelete() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        /*for (let i = 0; i < that.dataNext.length; i++) {
                            for (let j = 0; j < that.dataChecked.length; j++) {
                                if (that.dataNext[i].part_id == that.dataChecked[j]) {
                                    that.dataNext[i].IsDelete = 1;
                                }
                            }
                        }
                        let arr = that.dataNext.filter(item => {
                            return item.IsDelete != 1 || item.IsAdd != 1;
                        });
                        that.dataNext = arr;*/
                        let delrows = [];
                        for (let i = that.dataChecked.length - 1; i >= 0; i--) {
                            that.dataNext.splice(that.dataChecked[i].index, 1);
                            if (that.dataChecked[i].exclusively_id != "") {
                                let datatmp = {
                                    partid: that.dataChecked[i].part_id,
                                    parentpartid: that.dataChecked[i].parent_part_id,
                                    parent_routing_no: that.dataChecked[i].parent_routing_no
                                }
                                delrows.push(datatmp);
                            }
                        }
                        if (delrows.length > 0) {
                            that.loading = true;
                            let data = {
                                Dels: delrows
                            };
                            that.$http.urlpost('Eng/Boms/DelRowBomInfo', data, function (res) {
                                console.log(res);
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    /*that.reflashTree();*/
                                    that.btnauthority();
                                    that.getBOMInfo(that.PartId);
                                } else {
                                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                                }
                                that.loading = false;
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 查看BOM
            searchBOM() {
                let that = this
                let parm  = {
                    exclusively_id: that.dataChecked[0].part_id,
                    part_code: that.dataChecked[0].part_code,
                    part_version: that.dataChecked[0].part_version
                }
                that.pickclick(parm)
            },
            // 查看制造清单
            showProductList() {
                let that = this;
                that.isVisibleProductList = true;
                if (that.dataList.parentpartid == 0) {
                    that.dataSetProductList = [];
                } else {
                    let parm = {
                        Id: that.dataList.parentpartid
                    };
                    that.$http.urlpost('/Eng/Boms/GetBomProduceList', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSetProductList = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initAllForm()
                            })
                        }
                    });
                }
            },
            expProductList() {
                let that = this;
                let parm = {
                    Id: that.dataList.parentpartid
                };
                that.$http.urlpost('/Eng/Boms/GetBomProduceListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            showPurchaseList() {
                let that = this;
                that.isVisiblePurchaseList = true;
                if (that.dataList.parentpartid == 0) {
                    that.dataSetPurchaseList = [];
                } else {
                    let parm = {
                        Id: that.dataList.parentpartid
                    };
                    that.$http.urlpost('/Eng/Boms/GetBomPurchaseList', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSetPurchaseList = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initAllForm()
                            })
                        }
                    });
                }
            },
            expPurchaseList() {
                let that = this;
                let parm = {
                    Id: that.dataList.parentpartid
                };
                that.$http.urlpost('/Eng/Boms/GetBomPurchaseListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            showMaterialList() {
                let that = this;
                that.isVisibleMaterialList = true;
                if (that.dataList.parentpartid == 0) {
                    that.dataSetMaterialList = [];
                } else {
                    let parm = {
                        Id: that.dataList.parentpartid
                    };
                    that.$http.urlpost('/Eng/Boms/GetBomMaterialList', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSetMaterialList = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initAllForm()
                            })
                        }
                    });
                }
            },
            expMaterialList() {
                let that = this;
                let parm = {
                    Id: that.dataList.parentpartid
                };
                that.$http.urlpost('/Eng/Boms/GetBomMaterialListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            showBomHistoryList() {
                let that = this;
                that.isVisibleBomHistoryList = true;
                if (that.dataList.parentpartid == 0) {
                    that.dataSetBomHistoryList = [];
                } else {
                    let parm = {
                        Id: that.dataList.parentpartid
                    };
                    that.$http.urlpost('/Eng/Boms/GetBomHistoryList', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSetBomHistoryList = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initAllForm()
                            })
                        }
                    });
                }
            },
            expBomHistoryList() {
                let that = this;
                let parm = {
                    Id: that.dataList.parentpartid
                };
                that.$http.urlpost('/Eng/Boms/GetBomHistoryListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            showBomPurchaseProc(){
                let that = this;
                that.isVisibleBomPurchaseProc = true;
                if (that.dataList.parentpartid == 0) {
                    that.dataSetBomPurchaseProc = [];
                } else {
                    let parm = {
                        Id: that.dataList.parentpartid
                    };
                    that.$http.urlpost('/Eng/Boms/GetBomPurchaseProcList', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSetBomPurchaseProc = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initAllForm()
                            })
                        }
                    });
                }
            },
            expBomPurchaseProc(){
                let that = this;
                let parm = {
                    Id: that.dataList.parentpartid
                };
                that.$http.urlpost('/Eng/Boms/GetBomPurchaseProcListToExcel', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            showBomManHour(){
                let that = this;
                that.isVisibleBomManHour = true;
                if (that.dataList.parentpartid == 0) {
                    that.dataSetBomManHour = [];
                } else {
                    let parm = {
                        Id: that.dataList.parentpartid
                    };
                    that.$http.urlpost('/Eng/Boms/GetBindBomManhourList', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSetBomManHour = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initAllForm()
                            })
                        }
                    });
                }
            },
            BomNUsableToExecl(){
                let that = this;
                let parm = {
                    Id: that.dataList.parentpartid
                };
                that.$http.urlpost('/Eng/Boms/GetBomNUsableToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            expBomManHour(){
                let that = this;
                let parm = {
                    Id: that.dataList.parentpartid
                };
                that.$http.urlpost('/Eng/Boms/GetBindBomManhourListToExcel', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            //查看自制件工艺工价
            getBomMadeList(){
                let that = this
                that.isVisibleBomMadeList = true;
                if (that.dataList.parentpartid == 0) {
                    that.dataSetBomMadeList = [];
                } else {
                    let parm = {
                        Id: that.dataList.parentpartid
                    };
                    that.$http.urlpost('Eng/Boms/GetBomMadeList', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSetBomMadeList = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initAllForm()
                            })
                        }
                    });
                }
            },
            expBomMadeList(){
                let that = this;
                let parm = {
                    Id: that.dataList.parentpartid
                };
                that.$http.urlpost('/Eng/Boms/GetBomMadeListToExcel', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            copy() {
                this.$refs.copybom.clearInput(true);
            },
            getcopybom(data) {
                let that = this;
                let parm = {
                    Id: data.parent_part_id
                };
                that.$http.urlpost('/Eng/Boms/GetBOMPartInfoByID', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent.listNextModel;
                        that.iscopy=1;
                        for (let i = 0; i < data.length; i++) {
                            data[i].IsAdd = 1;
                            that.dataNext = [...that.dataNext, data[i]];
                        }
                    }
                });
            },
            // 字段解析
            expMPFlag(val) {
                console.log('难受' + val);
                if (val == 0) {
                    return '采购'
                } else if (val == 1) {
                    return '制造'
                } else {
                    return ''
                }
            },
            imp() {
                let item = {
                    //label: 'BOM导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/1',
                    url: '/exp/1',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/1'});
                this.$store.commit('selectMenu', item);
            },
            //
            transferRouting(){
                let that = this
                let parm = {
                    partid: that.dataList.parentpartid,
                    routing_version: that.routing_version
                }
                that.$http.urlpost('/Eng/Boms/GetRoutingList', parm, function (res) {
                    if (res.Success == 1) {
                        that.arrRouting = res.DataContent.List
                        that.isVisibleRouting = true
                    }
                });
            },
            confirmTransferRouting(){
                let that = this
                that.isVisibleRouting = false
                let selectList = {}
                for(let i = 0;i<that.arrRouting.length;i++){
                    if(that.selectRouting == that.arrRouting[i].routing_index){
                        selectList = that.arrRouting[i]
                        break;
                    }
                }
                for(let i = 0;i<that.dataNext.length;i++){
                    for(let j = 0;j<that.dataChecked.length;j++){
                        if(that.dataNext[i].index == that.dataChecked[j].index){
                            that.dataNext[i].routing_sequence = selectList.routing_sequence_no
                            that.dataNext[i].parent_routing_no = selectList.routing_index
                            that.dataNext[i].workproc_name = selectList.workproc_name
                        }
                    }
                }
                for(let i = 0;i<that.dataNext.length;i++){
                    for(var j = i+1;j<that.dataNext.length;j++){
                        if(that.dataNext[i].part_name + that.dataNext[i].part_version + that.dataNext[i].routing_sequence == that.dataNext[j].part_name + that.dataNext[j].part_version + that.dataNext[j].routing_sequence){
                            that.dataNext[i].std_qty = that.dataNext[i].std_qty + that.dataNext[j].std_qty
                            that.dataNext.splice(j,1)
                            break
                        }
                    }
                }
            },
            // 拆分物料工序
            splitRouting(){
                let that = this
                let parm = {
                    partid: that.exclusively_id,
                    routing_version: that.routing_version,
                    routing_sequence: that.dataChecked[0].routing_sequence,
                    parent_routing_no: that.dataChecked[0].parent_routing_no
                }
                that.$http.urlpost('/Eng/Boms/GetBomRoutingList', parm, function (res) {
                    if (res.Success == 1) {
                        that.arrSplitRouting = res.DataContent.List
                        that.dataSplit.amount = that.dataChecked[0].std_qty
                        that.showSplitRouting = true
                    }
                });
            },
            confirmSplitRouting(){
                let that = this
                if(that.dataSplit.amount > that.dataChecked[0].std_qty){
                    that.$message.warning(that.$t('getapi[8701]'))//'数字大于可拆分的最大数！'
                    return
                }
                let arr = {}
                for(let i = 0;i<that.arrSplitRouting.length;i++){
                    if(that.dataSplit.routing == that.arrSplitRouting[i].routing_index){
                        arr = that.arrSplitRouting[i]
                    }
                }
                let isexist = false
                let index = ''
                for(let i = 0;i<that.dataNext.length;i++){
                    if(that.dataNext[i].part_name == that.dataChecked[0].part_name && that.dataNext[i].workproc_name == arr.workproc_name && arr.routing_sequence_no == that.dataNext[i].routing_sequence){
                        isexist = true
                        index = i
                    }
                }
                if(isexist){
                    console.log(that.dataNext[index].std_qty)
                    console.log(that.dataSplit.amount)
                    that.dataNext[index].std_qty = parseFloat(that.dataNext[index].std_qty) + parseFloat(that.dataSplit.amount)
                    if(that.dataSplit.allchecked == true || that.dataSplit.amount == that.dataChecked[0].std_qty){
                        that.dataNext.splice(that.dataChecked[0].index, 1)

                    } else {
                        that.dataNext[that.dataChecked[0].index].std_qty = parseFloat(that.dataNext[that.dataChecked[0].index].std_qty) - parseFloat(that.dataSplit.amount)
                    }
                } else{
                    if(that.dataSplit.allchecked == true || that.dataSplit.amount == that.dataChecked[0].std_qty){
                        that.dataNext[that.dataChecked[0].index].routing_sequence = arr.routing_sequence_no
                        that.dataNext[that.dataChecked[0].index].workproc_name = arr.workproc_name
                    } else {
                        that.dataNext[that.dataChecked[0].index].std_qty = parseFloat(that.dataNext[that.dataChecked[0].index].std_qty) - parseFloat(that.dataSplit.amount)
                        that.dataNext = [...that.dataNext,{
                            part_id:that.dataChecked[0].part_id,
                            parent_part_id:that.dataChecked[0].parent_part_id,
                            part_code:that.dataChecked[0].part_code,
                            part_name:that.dataChecked[0].part_name,
                            part_version:that.dataChecked[0].part_version,
                            std_qty:that.dataSplit.amount,
                            part_master_unit:that.dataChecked[0].part_master_unit,
                            part_spec: that.dataChecked[0].part_spec,
                            part_model: that.dataChecked[0].part_model,
                            part_stuff: that.dataChecked[0].part_stuff,
                            mp_flag:that.dataChecked[0].mp_flag,
                            scatter_qty:that.dataChecked[0].scatter_qty,
                            bom_status:that.dataChecked[0].bom_status,
                            multi_material_cost:that.dataChecked[0].multi_material_cost,
                            create_person:that.dataChecked[0].create_person,
                            create_time:that.dataChecked[0].create_time,
                            audit_time:that.dataChecked[0].audit_time,
                            audit_person:that.dataChecked[0].audit_person,
                            modify_person:that.dataChecked[0].modify_person,
                            modify_time:that.dataChecked[0].modify_time,
                            std_qty_include_scrap:that.dataChecked[0].std_qty_include_scrap,
                            planning_code:that.dataChecked[0].planning_code,
                            parent_routing_no:arr.routing_index,
                            routing_sequence:arr.routing_sequence_no,
                            workproc_name:arr.workproc_name,
                            board_flag: that.dataChecked[0].board_flag,
                            exclusively_id:'',
                            IsAdd:0,
                            IsDelete:0
                        }]
                    }
                }
                that.showSplitRouting = false
            },
            // 获取物料信息
            getMaterial(){
                let that = this
                that.$store.commit('setSharedParams', {
                    id: that.PartId
                });
                let item = {
                    label: this.$t("getapi[56]"),
                    name: 'mater',
                    path: '/mater',
                    url: '/mater',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/mater'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            // 获取工艺信息
            getCraft(){
                let that = this
                let parm = {
                    Id : that.PartId
                }
                that.$http.urlpost('/Eng/Routings/GetRouttingIDByPartId', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res.UniqueNum)
                        let Id = res.UniqueNum
                        that.$store.commit('setSharedParams', {
                            id: Id
                        });
                        let item = {
                            label: that.$t("getapi[64]"),
                            name: 'carft',
                            path: '/carft',
                            url: '/carft',
                            icon: 'video-play'
                        };
                        that.$router.push({ path: 'carft'});
                        that.$store.commit('selectMenu', item);
                        that.$limits.cachePage(item)
                    }
                });
            },
            // 查找定位
            searchPosition(){
                let that = this
                that.isVisiblePosition = true
            },
            confirmSearchPosition(){
                let that = this
                if(that.positionKey == ''){
                    return
                }
                let row = null
                for(let i =0;i<that.dataNext.length;i++){
                    if(that.positionKey.toUpperCase() == that.dataNext[i].part_code.toUpperCase()){
                        row = that.dataNext[i]
                    }
                }
                if(row != null){
                    that.$refs.singleTable.setCurrentRow(row);
                    setTimeout(() => {
                        let node = document.querySelector('.el-table__body tr.current-row');
                        if (node) {
                            setTimeout(() => {
                                let top = $(node).position().top;
                                this.$refs.singleTable.bodyWrapper.scrollTop = top;
                            }, 200);
                        }
                    }, 0);
                    that.isVisiblePosition =  false
                } else {
                    that.isVisiblePosition =  false
                }
            },
            // 设置节点颜色
            renderContent(h, { node, data, store }) {
                let that = this
                let color = '';
                let type = node.level % 3
                if (type === 0) {
                    color = '#67C23A';
                } else if (type === 1) {
                    color = '#000';
                } else {
                    color = '#4498ff';
                }
                const imgUrl = require('../../../../assets/img/unuse.png');
                if (data.Bom_status != 0) {
                    return (
                    <span class="custom-tree-node">
                        <img src={imgUrl} width="12px" height="12px" class="favicon"/><span style={`color: ${color}`}> {node.label}</span>
                    </span>
                )} else {
                    return (
                        <span class="custom-tree-node">
                        <span style={`color: ${color}`}> {node.label}</span>
                    </span>
                );
                }
            },
            previous(){
                let that = this
                for(let i = (that.searchindex -1);i >= 0;i--){
                    this.$refs.tree.setCurrentKey(this.searchData[i].Part_id);
                    that.searchindex = i
                    break
                }
            },
            next(){
                let that = this
                if(that.searchindex == -1){
                    for(let i = 0;i<that.searchData.length;i++){
                        that.defaultEexpandedkeys = that.getParentsId(that.searchData[that.searchindex], that.dataTree, 'Part_id','Parent_part_id', that.parentid);
                        this.$refs.tree.setCurrentKey(this.searchData[i].Part_id);
                        that.searchindex = i
                        break
                    }
                } else {
                    for(let i = (that.searchindex + 1);i<that.searchData.length;i++){
                        that.defaultEexpandedkeys = that.getParentsId(that.searchData[that.searchindex], that.dataTree, 'Part_id','Parent_part_id', that.parentid);
                        this.$refs.tree.setCurrentKey(this.searchData[i].Part_id);
                        that.searchindex = i
                        break
                    }
                }
            },
            getSearchNode:function(){
                let that = this
                let recursiveArray = function(arr){
                    if(arr.Bom_status != 0){
                        that.searchData.push(arr)
                    }
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu)
                        }
                        return that.searchData
                    }
                }
            },
            getParentsId(node, data, PerID, ParentID, rootId, parentsId = [] ){
                let that = this
                if(!node) return [rootId, ...parentsId];
                if(node[ParentID] == rootId) return [node[ParentID], ...parentsId];
                let pNode = that.getParentNode(node[ParentID]).filter(data)
                if(!pNode.length) return parentsId;
                parentsId.push(pNode[0][PerID]);
                return that.getParentsId(pNode[0], data, PerID, ParentID, rootId, parentsId);
            },
            getParentNode: function(ParentID){
                let that = this
                let parentID = []
                let recursiveArray = function(arr){
                    if(arr.Part_id == ParentID){
                        parentID.push(arr)
                        return
                    } else {
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return false
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu);
                        }
                        return parentID
                    }
                }
            },
            selectInfo(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name; //右侧明细当前页面
                this.$nextTick(function(){
                    this.$processdata.initFormRight(this.RightSelectIndex)
                });
            },
            //更新底层码
            updatePartLLC(){
                let that = this
                let parm = {}
                that.$http.urlpost('/Eng/Boms/UpdatePartLLC', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            //双击直接上级信息获取树结构和明细信息
            getUpData(row){
                let that = this
                that.routing_version = row.routing_version
                that.level0Part = row.part_code + '─→' + row.part_version;
                that.exclusively_id=row.exclusively_id;//选择根节点物料id
                that.getBOMTree(row.exclusively_id);
                that.getBOMInfo(row.exclusively_id);
                that.authority();
                that.btnauthority();
            },
            sortChange(column){
                let that = this
                let name = column.prop
                console.log(that.dataNext)
                if(column.order == "ascending"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataNext.indexOf(obj1) - that.dataNext.indexOf(obj2);
                        }
                    }
                    that.dataNext = that.dataNext.sort(compare)
                    that.dataNext= [...that.dataNext];
                    console.log(that.dataNext)
                } else if(column.order == "descending"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataNext.indexOf(obj2) - that.dataNext.indexOf(obj1);
                        }
                    }
                    that.dataNext = that.dataNext.sort(compare)
                    that.dataNext= [...that.dataNext];
                    console.log(that.dataNext)
                }
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv2', 31,2) < 1){
                    return false
                }
                let flag = that.oldDataList != JSON.stringify(that.dataList)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
        min-width: 120px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }

    /*.el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none;
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none;
    }*/

    .el-table .hidden-row {
        display: none;
    }

    .size_large {
        width: 100%;
    }

    .size_normal {
        width: 70%;
    }

    .size_small {
        width: 40%;
    }

    .el-form--inline .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
    }

    .box {
        width: 100%;
        overflow-x: auto;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
            }
        }
    }
    /deep/.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        background-color: lightskyblue;
    }
    /deep/ .red {
        background: #ff7879;
    }

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .hidden {
        display: none;
    }
    /deep/ .yellow {
        background: #fff866;
    }

    .tree /deep/ .el-tree-node {
        position: relative;
        padding-left: 0 ;
    }

    .tree /deep/ .el-tree-node__children {
        padding-left: 16px;
    }

    .tree /deep/ .el-tree-node :last-child:before {
        height: 12px;
    }

    .tree /deep/ .el-tree > .el-tree-node:before {
        border-left: none;
    }

    .tree-container /deep/ .el-tree > .el-tree-node:after {
        border-top: none;
    }

    .tree /deep/ .el-tree-node:before {
        content: '';
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
        border-left: 1px dashed #4386c6;
        bottom: 0px;
        height: 100%;
        top: 0px;
        width: 1px;
    }

    .tree /deep/ .el-tree-node:after {
        content: '';
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
        border-top: 1px dashed #4386c6;
        height: 20px;
        top:12px;
        width: 10px ;
    }
</style>
